import { createSelector } from 'reselect'

const stateSelector = state => state.cookies

export const showCookiesModalSelector = createSelector(
    stateSelector,
    state => !state.cookiesAccepted || state.cookiesModalOpen
)

export const cookiesAcceptedSelector = createSelector(stateSelector, state => state.cookiesAccepted)
